import { CommunityNotificationsBadge } from "@circleco/community-switcher/components/CommunityNotificationsBadge";
import { Tooltip } from "@circleco/compass/components/Tooltip";
import type { CSSProperties } from "react";

import { CommunitySectionPresentationContent } from "./CommunitySectionPresentationContent";
import { CommunitySectionTooltipContent } from "./CommunitySectionTooltipContent";
import { CommunitySwitcherAvatar } from "./CommunitySwitcherAvatar";

export interface CommunitySectionPresentationProps {
  readonly communityId: number;
  readonly href: string;
  readonly hotkeyPosition?: number;
  readonly iconUrl: string;
  readonly isActive: boolean;
  readonly isElectron?: boolean;
  readonly name: string;
  readonly notificationCount: number;
  readonly onElectronActivate?: () => void;
  readonly tooltipLabel: string;
  readonly brandColor?: string;
  readonly lightBrandColor?: string;
  readonly darkBrandColor?: string;
  readonly dragHandleRef?: (element: Element | null) => void;
  readonly dragHandleStyle?: CSSProperties;
}

export const CommunitySectionPresentation = ({
  communityId,
  href,
  hotkeyPosition,
  iconUrl,
  isActive,
  isElectron,
  name,
  notificationCount,
  onElectronActivate,
  tooltipLabel,
  brandColor,
  lightBrandColor,
  darkBrandColor,
  dragHandleRef,
  dragHandleStyle,
}: CommunitySectionPresentationProps) => {
  return (
    <Tooltip
      content={
        <CommunitySectionTooltipContent
          name={tooltipLabel}
          hotkeyPosition={hotkeyPosition}
        />
      }
      delay={200}
      side="right"
      sideOffset={12}
    >
      <span data-testid="community-switcher-item" className="inline-flex">
        <CommunitySectionPresentationContent
          communityId={communityId}
          isElectron={isElectron}
          tooltipLabel={tooltipLabel}
          isActive={isActive}
          onElectronActivate={onElectronActivate}
          href={href}
          name={name}
          notificationCount={notificationCount}
          dragHandleRef={dragHandleRef}
          dragHandleStyle={dragHandleStyle}
        >
          <span className="relative inline-flex">
            <CommunitySwitcherAvatar
              iconUrl={iconUrl}
              name={name}
              brandColor={brandColor}
              lightBrandColor={lightBrandColor}
              darkBrandColor={darkBrandColor}
            />
            <CommunityNotificationsBadge
              notificationCount={notificationCount}
            />
          </span>
        </CommunitySectionPresentationContent>
      </span>
    </Tooltip>
  );
};
